import React, { useEffect, useState } from "react";
import SearchForm from "../SearchForm/SearchForm";
import { ShoppingCart, UserCircle, Menu } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Logo from "../../assets/images/LEFTKOAST-LOGO.png";
import "./Topnav.css";

function Topnav({ setOpenSidenav }) {
  const { user } = useSelector((state) => state.auth);
  const { items } = useSelector((state) => state.cart);

  const [scrolled, setScrolled] = useState(false);

  const navigate = useNavigate();

  const handleMenuClick = () => {
    setOpenSidenav((prev) => !prev);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`Topnav ${scrolled ? "scrolled" : ""}`}>
      <div className="topnav-left">
        <button className="menu-icon" onClick={handleMenuClick}>
          <Menu size={25} color="white" />
        </button>
        <img
          className="logo-mobile"
          src={Logo}
          alt="logo"
          width={25}
          height={25}
        />
        <SearchForm />
      </div>
      <ul>
        <li className="user-icon">
          <Link to={user ? "/profile" : "/login"}>
            <UserCircle size={18} />
            {user ? user.username : "Login"}
          </Link>
        </li>
        <li>
          <button
            onClick={() => {
              navigate("/cart");
            }}
          >
            <ShoppingCart size={14} color="#fff" />
            <p>{items ? items?.length : 0}</p>
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default Topnav;
